<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCol xs="12" lg="12" style="margin-top: 20px">
        <CTabs variant="pills">
          <CTab title="Scramble Quiz Points" active>
            <hr />
            <ScramblequizPoint> </ScramblequizPoint>
          </CTab>
          <CTab title="DFS Quiz Points">
            <hr />
            <DFSquizPoint></DFSquizPoint>
          </CTab>
          <CTab title="DFS Prediction Points">
            <Predictionpoints></Predictionpoints>
          </CTab>
          <CTab title="DFS Betting Points">
            <Bettingpoints></Bettingpoints>
          </CTab>
         
        </CTabs>
      </CCol>
    </CCard>
  </div>
</template>
<script>
import ScramblequizPoint from "./scramblequizpoint.vue";
import DFSquizPoint from "./dfsquizpoint.vue";
import Predictionpoints from "./predictionpoints.vue";
import Bettingpoints from "./bettingpoints.vue";

export default {
  components: {
    ScramblequizPoint,
    DFSquizPoint,
    Predictionpoints,
    Bettingpoints
   
  },
  data() {
    return {
      activeTab: 1,
    };
  },
};
</script>